module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative sider sider-bg"
  }, [_c('div', {
    staticClass: "tc mb4 flex justify-center items-center padding"
  }, [_c('div', {
    staticClass: "flex steps"
  }, [_c('div', {
    staticClass: "line bg-gray"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column items-start justify-between menu steps"
  }, _vm._l((_vm.statusData), function(status) {
    return _c('progress-status', {
      key: status.thisStep,
      attrs: {
        "currentStep": _vm.currentStep,
        "thisStep": status.thisStep,
        "stepLabel": status.label
      }
    })
  }), 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4c3c4e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/progressSideBar/RedeemProgress.vue
// module id = 649
// module chunks = 0